export default __webpack_public_path__ + "static/media/elo-logo.e5a0efd8.svg";